import { render, staticRenderFns } from "./EdgeCache.vue?vue&type=template&id=dec8cc9a&scoped=true"
import script from "./EdgeCache.vue?vue&type=script&lang=js"
export * from "./EdgeCache.vue?vue&type=script&lang=js"
import style0 from "./EdgeCache.vue?vue&type=style&index=0&id=dec8cc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec8cc9a",
  null
  
)

export default component.exports